<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import AppHeader from '@/components/app/AppHeader.vue'
import { OptionsSnackbar } from '@haskoning/vue-component-library'

import { useAuthenticationStore } from '@/stores/authentication'

const { user } = storeToRefs(useAuthenticationStore())
</script>

<template>
	<v-app>
		<AppHeader v-if="user"></AppHeader>
		<v-main class="app-main">
			<router-view />
			<OptionsSnackbar style="z-index: 3000" :excluded-http-methods="['GET', 'OPTIONS', 'PATCH']" />
		</v-main>
	</v-app>
</template>

<style lang="scss">
@use '/src/scss/settings.scss';

.app-main {
	height: 100vh;
	min-height: 0;
}

.app-main > * {
	height: 100%;
	min-height: 0;
}
</style>
